/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {useMemo} from 'react';
import {GenericObject} from '@ion/core/src/types/entities';

/**
 * The useServiceBasedFeatures hook provides the Services List which are accessible to user
 * Based on the permissions of authenticated user.
 *
 * ```typescript
 * import {useServiceBasedFeatures} from '@ion/packages/query/src/hooks';
 *  ...
 *  const services = useServiceBasedFeatures(Features);
 *
 */
export const useServiceBasedFeatures = (Features: GenericObject): string[] => {
  const allServices = {
    ICN   : Features.hasICN(),
    BLE   : Features.hasBLE(),
    IVT   : Features.hasIVT(),
    CARGO : Features.hasCARGO(),
    DOOR  : Features.hasDOOR(),
    TPMS  : Features.hasTPMS(),
    WETS  : Features.hasWETS(),
    BMS   : Features.hasBMS(),
    LMS   : Features.hasLMS(),
    WMS   : Features.hasWMS(),
    EA    : Features.hasEA()
  };

  const allowedServices = useMemo(() => (
    Object.keys(allServices).filter(service => allServices[service])
  ), [allServices]);

  return allowedServices;
};

export default useServiceBasedFeatures;
